module.exports = __webpack_public_path__ + "static/Altero-Regular-a56964e174ef2d44dc08a27c33d7e16d.ttf";